<template>
  <div class="lesson">
    <top-nav :list="topList"></top-nav>
    <div class="content-wrapper">
      <div class="top-btn-wrapper">
        <button class="back-btn" @click="goback">
          <返回作业
        </button>
        <button class="enter-btn" v-if="!isEmpty(classList)" @click="openCreateTitle">创建作业</button>
      </div>
      <div class="noresult" v-if="isEmpty(classList)">
        <img src="./noresult.png" width="290" height="164" alt="没有结果">
        <p class="noresult-text">~暂无班级可以创建作业~</p>
      </div>
      <div class="list-wrapper" v-else>
        <template v-for="(item,index) in classList">
          <div class="list-item">
            <span class="select-icon" @click="choseClassid=item.classid;choseClass=item"
                  :class="{'selected':item.classid===choseClassid}"></span>
            <img class="item-img" width="168" height="114" :src="imgprefix+item.faceimg" alt="picture">
            <div class="class-content-wrapper">
              <h3 class="item-class-name">{{decodeURIComponent(item.classname)}}</h3>
              <p class="item-lesson-name">{{decodeURIComponent(item.lessonname)}}</p>
              <p class="item-student-name">
                <template v-for="item2 in item.studentname">{{decodeURIComponent(item2.username)}}</template>
              </p>
            </div>
          </div>
        </template>
      </div>
      <template v-if="!isEmpty(classList)&&(totalPage>12)">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :page-size="8"
          :total="totalPage">
        </el-pagination>
      </template>
    </div>
    <div class="create-mask" v-if="createTitleShow">
      <div class="createpop">
        <input type="text" v-model="homeworkTitle" class="title-input" placeholder="请填写作业标题">
        <span class="left">难易等级：</span>
        <select name="type"
                class="type-select"
                v-model="worklevel">
          <option disabled selected value="default" class="select-hint">请选择</option>

          <option class="select-item" value="0">简单</option>
          <option class="select-item" value="1">中等</option>
          <option class="select-item" value="2">困难</option>

        </select>
        <button class="cancel" @click="hideCreateTitle">取消</button>
        <button class="confirm" @click="AddClassWork">进入编辑器</button>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import topNav from 'components/topnav/TopNav'
  import aboveNav from 'components/abovenav/AboveNav'
  import sideNav from 'components/sidenav/SideNav'
  import {toMinutes} from 'common/js/toMinutes.js';

  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        imgprefix: '',
        topList: [
          {
            name: '选择班级',
            to: '/console/homework/create',
          }
        ],
        choseClassid: null,
        choseClass: null,
        createTitleShow: false,
        homeworkTitle: null,
        worklevel: 'default',       //难易等级
        //---------------------课程列表及翻页-----------------------//
        currentPage: 1,
        totalPage: 1,
        classList: [],                   //从服务端获取到的课程列表（总）
      }
    },
    methods: {
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      goback() {
        window.history.go(-1);
      },
      openCreateTitle() {
        if (this.choseClassid == null) {
          this.$message({
            message: '请先选择班级',
            type: 'warning'
          })
          return;
        }

        this.homeworkTitle = null;
        this.worklevel = 'default';
        this.createTitleShow = true;
      },
      hideCreateTitle() {
        this.createTitleShow = false;
        this.homeworkTitle = null;
        this.worklevel = 'default';
      },
      //当页面发生改变时
      handleCurrentChange(val) {
        this.choseClassid = null;
        this.choseClass = null;
        this.QueryFormalClass(val);
      },
      //根据传入的数字，获取相应的课程列表
      QueryFormalClass(pageno) {
        //接口：查询指定用户课程列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'HomeWork',
            a: 'QueryClassForHomeWork',
            id: this.id,
            rid: this.schoolNow.rid,
            pageno: pageno,
            pagesize: 12,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            if (!this.imgprefix) {
              this.imgprefix = response.imgprefix;
            }
            this.classList = response.list;
            this.totalPage = Number(response.recordcount);
          }

        }).catch((err) => {
        })
      },
      AddClassWork() {
        if (this.homeworkTitle == null) {
          this.$message({
            message: '请输入作业标题',
            type: 'warning'
          })
          return;
        }
        if (this.worklevel == 'default') {
          this.$message({
            message: '请选择难易等级',
            type: 'warning'
          })
          return;
        }
        this.$router.push(
          {
            path: '/homework/init',
            query: {
              title: this.homeworkTitle,
              worklevel:this.worklevel,
              rid: this.choseClass.rid,
              lessonid: this.choseClass.lessonid,
              classid: this.choseClassid
            }
          }
        )
      },
    },
    created() {
      this.QueryFormalClass(1);
    },
    components: {
      sideNav,
      aboveNav,
      topNav
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .lesson {
    position fixed
    left: 160px
    top: 91px
    right: 0
    bottom: 0
    background #f2f2f2
    overflow auto
    z-index: 10
    .content-wrapper {
      padding: 20px 0 0 20px
      width: 1166px
      .top-btn-wrapper {
        height: 40px
        margin-bottom: 20px
        .back-btn {
          float: left
          display: inline-block
          width: 114px
          height: 40px
          line-height: 40px
          font-size: 16px
          color: #333333
          border-radius: 4px
          background: #fff
        }
        .enter-btn {
          float: right
          display: inline-block
          width: 114px
          height: 40px
          line-height: 40px
          font-size: 16px
          color: #fff
          border-radius: 4px
          background: #3399ff
          &:hover {
            background: #5eaefe
          }
        }
      }
      .noresult {
        background: #fff
        height: 550px
        padding-top: 120px
        text-align: center
        box-sizing: border-box
        .noresult-text {
          font-size: 18px
          color: #a5a5a5
          margin-top: 10px
          line-height: 25px
        }
      }
      .list-wrapper {
        overflow: hidden
        .list-item {
          float: left;
          margin: 0 10px 10px 0;
          height: 114px;
          width: 558px;
          padding: 10px;
          background: #fff;
          border-radius: 6px;
          position: relative
          &:nth-child(2n) {
            margin-right: 0px;
          }
          .select-icon {
            position: absolute;
            right: 20px;
            top: 55px;
            display: inline-block
            width: 26px;
            height: 26px;
            cursor: pointer;
            background: url('./beforeselect.png') no-repeat center / 26px 26px
            &.selected {
              background: url('./selected.png') no-repeat center / 26px 26px
            }
          }
          .item-img {
            float: left
          }
          .class-content-wrapper {
            float: left
            margin-left: 20px
            width: 330px
            .item-class-name {
              margin-top: 23px;
              font-size: 18px
              color: #333333
              height: 25px
              line-height: 25px
              font-weight: bold
            }
            .item-lesson-name, .item-student-name {
              margin-top: 10px
              font-size: 16px;
              color: #999999;
              height: 22px;
              line-height: 22px;
              overflow: hidden
              text-overflow: ellipsis
              white-space: nowrap
            }
          }
        }
      }
    }
    .create-mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      text-align: center;
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      &::after {
        content: "";
        display: inline-block;
        height: 100%;
        width: 0;
        vertical-align: middle;
      }
      .createpop {
        display: inline-block;
        width: 400px;
        height: 246px;
        vertical-align: middle;
        background-color: #fff;
        border-radius: 10px;
        .title-input {
          margin: 40px 30px 20px;
          height: 48px;
          line-height: 48px;
          width: 338px;
          border: 1px solid #a5a5a5;
          font-size: 16px;
          text-align: center;
          border-radius: 6px;
          color: #333;
          &::-webkit-input-placeholder, &:-moz-placeholder, &::-moz-placeholder, &:-ms-input-placeholder {
            color: #a5a5a5
          }
        }
        .left {
          display: inline-block
          margin-right: 10px
          line-height: 48px
          font-size: 16px
          color: #333
        }
        .type-select {
          width: 246px
          font-size: 16px
          border: 1px solid #a5a5a5
          height: 48px
          -webkit-appearance: none
          -moz-appearance: none
          appearance: none
          background: #fff url('./down.png') no-repeat right 9px center
          background-size: 12px 12px
          padding: 0 30px 0 6px
          border-radius: 4px
          box-sizing: border-box
        }
        .cancel, .confirm {
          display: inline-block;
          margin-top: 20px
          width: 160px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          font-size: 15px;
          color: #fff;
          border-radius: 4px;
        }
        .cancel {
          margin-right: 20px;
          background: #ccc;
        }
        .confirm {
          background: #3399ff;
          &:hover {
            background: #5eaefe
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/page/teacherhomework/create/assignwork.vue